export default "__VITE_ASSET__DQnICIFm__"